import { KeycloakState, RootState } from '../types'

export const SET_KEYCLOAK_DATA = 'keycloak//SET_KEYCLOAK_DATA'
export const SET_KEYCLOAK_IDP = 'keycloak//SET_KEYCLOAK_IDP'
export const SET_KEYCLOAK_IDP_HINT = 'keycloak//SET_KEYCLOAK_IDP_HINT'
export const SET_IS_LOGGED = 'keycloak//SET_IS_LOGGED'

interface SetKeycloakDataAction {
  type: typeof SET_KEYCLOAK_DATA
  payload: KeycloakState['data']
}

interface SetKeycloakIdpAction {
  type: typeof SET_KEYCLOAK_IDP
  payload: KeycloakState['idp']
}

interface SetKeycloakIdpHintAction {
  type: typeof SET_KEYCLOAK_IDP_HINT
  payload: KeycloakState['idpHint']
}

interface SetIsLoggedAction {
  type: typeof SET_IS_LOGGED
  payload: KeycloakState['isLogged']
}

type KeycloakActions =
  | SetKeycloakDataAction
  | SetKeycloakIdpAction
  | SetKeycloakIdpHintAction
  | SetIsLoggedAction

export function setKeycloakData(
  data: KeycloakState['data']
): SetKeycloakDataAction {
  return {
    type: SET_KEYCLOAK_DATA,
    payload: data,
  }
}

export function setKeycloakIdp(
  idp: KeycloakState['idp']
): SetKeycloakIdpAction {
  return {
    type: SET_KEYCLOAK_IDP,
    payload: idp,
  }
}

export function setKeycloakIdpHint(
  idpHint: KeycloakState['idpHint']
): SetKeycloakIdpHintAction {
  return {
    type: SET_KEYCLOAK_IDP_HINT,
    payload: idpHint,
  }
}

export function setIsLogged(
  isLogged: KeycloakState['isLogged']
): SetIsLoggedAction {
  return {
    type: SET_IS_LOGGED,
    payload: isLogged,
  }
}

export function getKeycloakData(state: RootState): KeycloakState['data'] {
  return state.keycloak.data
}
export function getKeycloakIdp(state: RootState): KeycloakState['idp'] {
  return state.keycloak.idp
}
export function getIsLogged(state: RootState): KeycloakState['isLogged'] {
  return state.keycloak.isLogged
}

const initialState: KeycloakState = {
  data: {},
  idp: null,
  idpHint: null,
  isLogged: false,
}

// eslint-disable-next-line func-names
export default function keycloakReducer(
  state: KeycloakState | undefined,
  action: KeycloakActions
): KeycloakState {
  const currentState = state || initialState
  switch (action.type) {
    case SET_KEYCLOAK_DATA:
      return {
        ...currentState,
        data: action.payload,
      }

    case SET_KEYCLOAK_IDP:
      return {
        ...currentState,
        idp: action.payload,
      }

    case SET_KEYCLOAK_IDP_HINT:
      return {
        ...currentState,
        idpHint: action.payload,
      }
    case SET_IS_LOGGED:
      return {
        ...currentState,
        isLogged: action.payload,
      }

    default:
      return currentState
  }
}
